import "../App.css";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";

function ZineOrderConfirmationPage() {
  return (
    <div className="container text-center">
      <div className="m-auto desktopWidth50 card rounded-0 border-0 checkoutCard mb-3 p-3 bg-white ">
        <h1 className="fw-bold text-primary-color">
          Thank you for your order.
        </h1>
        <br />
        <p className="confirmationTextLarge ">
          Delighted to let you know your order is confirmed.
        </p>

        <p>
          Should you have any questions, do get in touch via the{" "}
          <Link to="/contact" className="orangeText">
            {" "}
            contact form
          </Link>{" "}
          on the website.
        </p>
        <br />
        <Link
          to="/events"
          className="p-2 rounded-0 desktopWidth50 m-auto fw-bold bg-primary-color text-white"
        >
          home of stories
        </Link>
      </div>
    </div>
  );
}

export default ZineOrderConfirmationPage;
